module.exports = __webpack_public_path__ + "static/img/dt1.49beb535.png";